import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    DoppeActionPriceData
} from '../../client-server-common';
import {DoppeHideableValue} from '../../client-server-common/types/doppe-hideable-value';

export namespace DoppeActionTypePatreon {
    export interface ActionSettings {
        patreonTierlink: string;
        priceData: DoppeHideableValue<DoppeActionPriceData>;
        items: string[];
        linkButtonText: string;
    }
}

export const doppeActionTypePatreon = doppeActionTypeDefineMetadata<DoppeActionTypePatreon.ActionSettings>({
    id: 'io.bymo.action/patreon',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        patreonTierlink: '',
        priceData: {
            actualPrice: '$10 Per Month',
        },
        items: ['Membership Benefit'],
        linkButtonText: 'See More',
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            patreonTierlink: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Url, BymoPagePropsContentSettingSemanticMeaning.EntityPageUrl),
            priceData: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.PriceData, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            items: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.ListOfTexts, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            linkButtonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
})